import { translations } from 'locales/translations';
import { __ } from 'utils/messages';

export default {
  attachments: () => __(translations.editProjectAttachmentSection.attachments, 'Attachments'),
  attachmentsList: () => __(translations.editProjectAttachmentSection.attachmentsList, 'Attachments List'),
  addAttachment: () => __(translations.editProjectAttachmentSection.addAttachment, 'Ajouter une piéce jointe'),
  image: () => __(translations.editProjectAttachmentSection.image, 'Image'),
  file: () => __(translations.editProjectAttachmentSection.file, 'File'),
  fileName: () => __(translations.editProjectAttachmentSection.fileName, 'File name'),
  country: () => __(translations.editProjectAttachmentSection.country, 'Country'),
  clientProjectFlow: () => __(translations.editProjectAttachmentSection.clientProjectFlow, 'Client Project Flow'),
  communication: () => __(translations.editProjectAttachmentSection.communication, 'Communication'),
  date: () => __(translations.editProjectAttachmentSection.date, 'Date'),
  publish: () => __(translations.editProjectAttachmentSection.publish, 'Publish'),
  legendAndCredits: () => __(translations.editProjectAttachmentSection.legendAndCredits, 'Lengend and credits'),
  principalImage: () => __(translations.editProjectAttachmentSection.principalImage, 'Principal Image'),
  imageOrder: () => __(translations.editProjectAttachmentSection.imageOrder, 'Order'),
  cover: () => __(translations.editProjectAttachmentSection.cover, 'PDF Image cover'),

  // attachments types
  contract: () => __(translations.editProjectAttachmentSection.contract, 'Contract'),
  contractual_plan: () => __(translations.editProjectAttachmentSection.contractual_plan, 'Contractual Plan'),
  images_photos: () => __(translations.editProjectAttachmentSection.images_photos, 'Images / Photos'),
  press: () => __(translations.editProjectAttachmentSection.press, 'Press'),
  honoraria_proposal: () => __(translations.editProjectAttachmentSection.honoraria_proposal, 'Honoraria Proposal'),
  hub: () => __(translations.editProjectAttachmentSection.hub, 'HUB'),
  three_d: () => __(translations.editProjectAttachmentSection.three_d, '3D'),
  video: () => __(translations.editProjectAttachmentSection.video, 'Video'),

  // attachment viewer
  imagePreview: () => __(translations.editProjectAttachmentSection.imagePreview, 'Image Preview'),
  manageImagesOrder: () => __(translations.editProjectAttachmentSection.manageImagesOrder, 'Manage Images in their display order'),
  noImagesAdded: () => __(translations.editProjectAttachmentSection.noImagesAdded, 'No images added yet. Add images to see them here.'),
  noImage: () => __(translations.editProjectAttachmentSection.noImage, 'No Image'),
  primary: () => __(translations.editProjectAttachmentSection.primary, 'Primary'),
  pending: () => __(translations.editProjectAttachmentSection.pending, 'Pending'),
};
